module.exports = __webpack_public_path__ + "img/timeline_mainevent-11.f2748e4b.jpg";